module.exports = __webpack_public_path__ + "img/title3.bc0a2c4e.png";